import { createParser, useQueryState } from 'nuqs'
import { isUuid } from '@joyful/utils'

/** Sentinel `?askAi=` value for a chat that has no conversation yet. */
export const AskAiNewConversationValue = 'new'

const parseAsAskAiPanelValue = createParser<string>({
  parse: (value) => {
    if (value === AskAiNewConversationValue || isUuid(value)) {
      return value
    }

    return null
  },
  serialize: (value) => {
    return value
  },
})

/**
 * URL state for the global "Ask AI" modal: absent means closed, `new` means a
 * fresh chat, and a conversation UUID selects that conversation. History is
 * pushed so the browser back button steps through open/select transitions.
 */
export function useAskAiQueryState() {
  return useQueryState(
    'askAi',
    parseAsAskAiPanelValue.withOptions({ history: 'push' }),
  )
}
